import { getRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const getCountriesRequest = () =>
  getRequest(apiEndpoints.common.getCountries);

export const getCountryStatesRequest = (payload) =>
  getRequest(replaceInUrl(apiEndpoints.common.getCountryStates, payload));
